import React, { useState } from "react";
import TextEditor from "@icarius-common/textEditor";
import { Checkbox, Typography } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import { useDispatch } from "react-redux";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import Container from "../../../container";
import TextFieldMultiline from "@icarius-common/textFieldMultiline";

const EvaluationContent = (props) => {

    const {
        readOnly,
        data,
        isInstructor,
        handleSubmit,
        renderSolveButton,
    } = props;

    const dispatch = useDispatch();
    const [answers, setAnswers] = useState(() => {
        return data?.map((question) => {
            if (question.type === "U") return question.answer !== null ? question.answer : null;
            if (question.type === "M") return question.answer || [];
            if (question.type === "D") return question.answer || "";
            return null;
        })
    });

    const handleSetAnswer = (questionIndex, newAnswer) => {
        const question = data[questionIndex];
        setAnswers((prev) => {
            const auxAnswers = [...prev];

            if (question.type === "D") {
                auxAnswers[questionIndex] = newAnswer;
            }

            if (question.type === "U") {
                auxAnswers[questionIndex] = auxAnswers[questionIndex] === newAnswer ? null : newAnswer;
            }

            if (question.type === "M") {
                if (auxAnswers[questionIndex].includes(newAnswer)) {
                    auxAnswers[questionIndex] = auxAnswers[questionIndex].filter((auxAnswer) => auxAnswer !== newAnswer);
                } else {
                    auxAnswers[questionIndex].push(newAnswer);
                }
            }

            return auxAnswers;
        })
    }

    const dataIsValid = () => {
        return !answers.some((answer) => {
            if (Array.isArray(answer) && !answer.length) return true;
            if (answer === null || answer === "") return true;
            return false;
        });
    }

    const getFormDataToSend = (dataToSend) => {
        const formDataToSend = new FormData();
        formDataToSend.append("answers", JSON.stringify(dataToSend.answers));

        return formDataToSend;
    }

    const submit = () => {
        if (!dataIsValid()) {
            dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
            return;
        }

        handleSubmit(getFormDataToSend({ answers }));
    }

    if (!data?.length) return null;

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: 10,
            }}
        >
            {
                data.map((question, questionIndex) => {
                    return (
                        <Container
                            key={questionIndex}
                            title={`${getLocalizedString("question")} ${questionIndex + 1}:`}
                        >
                            <div
                                style={{
                                    marginBottom: 10,
                                }}
                            >
                                <TextEditor
                                    initialValue={question.text}
                                    maxHeight={"100%"}
                                    disabled
                                />
                            </div>
                            {
                                (question.options || []).map((option, optionIndex) => {
                                    return (
                                        <Typography
                                            key={optionIndex}
                                            onClick={() => {
                                                if (readOnly) return;
                                                handleSetAnswer(questionIndex, optionIndex);
                                            }}
                                            style={{
                                                fontSize: 14,
                                                display: "flex",
                                                alignItems: "center",
                                                cursor: readOnly ? "" : "pointer"
                                            }}
                                        >
                                            <Checkbox
                                                checked={
                                                    (() => {
                                                        if (!answers?.length) return false;
                                                        if (question.type === "U") return answers[questionIndex] === optionIndex;
                                                        return answers[questionIndex].includes(optionIndex);
                                                    })()
                                                }
                                                style={{ cursor: readOnly ? "default" : "pointer", color: "var(--mainText)" }}
                                            />
                                            {option}
                                        </Typography>
                                    )
                                })
                            }
                            {
                                question.type === "D" && !isInstructor &&
                                <TextFieldMultiline
                                    disabled={readOnly}
                                    required
                                    fullWidth
                                    label={getLocalizedString("answer")}
                                    rows={3}
                                    margin={"none"}
                                    value={answers[questionIndex]}
                                    onChange={(e) => handleSetAnswer(questionIndex, e.target.value)}
                                    inputProps={{ spellCheck: 'false' }}
                                />
                            }
                        </Container>
                    )
                })
            }
            {renderSolveButton(submit)}
        </div>
    )
}

export default EvaluationContent;
